/** Dropdown options for Create Company wizard (shared with LabelDropdown). */

export const CREATE_COMPANY_CUSTOMER_TERM_OPTIONS = [
  { value: 'Customer', label: 'Customer' },
  { value: 'Client', label: 'Client' },
  { value: 'Patient', label: 'Patient' },
];

export const CREATE_COMPANY_VENDOR_TERM_OPTIONS = [
  { value: 'Vendor', label: 'Vendor' },
  { value: 'Supplier', label: 'Supplier' },
  { value: 'Provider', label: 'Provider' },
];

export const CREATE_COMPANY_FISCAL_YEAR_OPTIONS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
].map((month) => ({ value: month, label: month }));

export const CREATE_COMPANY_INVENTORY_SCHEME_OPTIONS = [
  { value: 'average', label: 'Average' },
];

/** Services / products offer type cards (Create Company wizard). */
export const CREATE_COMPANY_OFFER_TYPE_OPTIONS = [
  {
    value: 'services',
    icon: 'bi bi-gear',
    title: 'Services Only',
    description:
      'Such as consulting, rentals, gym membership, event services, construction and labor',
  },
  {
    value: 'products',
    icon: 'bi bi-box',
    title: 'Products Only',
    description:
      'Such as lamps, fertilizer, books, hardware, tickets, insurance policies',
  },
  {
    value: 'both',
    icon: 'bi bi-cart',
    title: 'Both Services and Products',
    description:
      'Such as a bicycle repair shop that sells bikes, a carpet installation company that sells carpet',
  },
];

export const CREATE_COMPANY_TAX_ITEM_TYPE_OPTIONS = [
  { value: 'transaction', label: 'One per transaction' },
  { value: 'detail', label: 'One per detail line' },
];

/** Primary currency list (value = ISO code). */
export const CREATE_COMPANY_CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD (United States Dollar) - $' },
  { value: 'AFN', label: 'AFN (Afghan Afghani)' },
  { value: 'ALL', label: 'ALL (Albanian Lek) - Lek' },
  { value: 'AOA', label: 'AOA (Angolan Kwanza) - Kz' },
  { value: 'ARS', label: 'ARS (Argentine Peso) - $' },
  { value: 'AMD', label: 'AMD (Armenian Dram)' },
  { value: 'AWG', label: 'AWG (Aruban Guilder)' },
  { value: 'AUD', label: 'AUD (Australian Dollar) - $' },
  { value: 'AZN', label: 'AZN (Azerbaijani Manat)' },
  { value: 'BSD', label: 'BSD (Bahamian Dollar) - B$' },
  { value: 'BHD', label: 'BHD (Bahraini Dinar) - BD' },
  { value: 'BDT', label: 'BDT (Bangladeshi Taka) - Tk' },
  { value: 'BBD', label: 'BBD (Barbadian Dollar) - Bds$' },
  { value: 'BYR', label: 'BYR (Belarusian Ruble) - Br' },
  { value: 'BZD', label: 'BZD (Belize Dollar) - BZ$' },
  { value: 'BTN', label: 'BTN (Bhutanese Ngultrum) - Nu.' },
  { value: 'BOB', label: 'BOB (Bolivian Boliviano) - Bs.' },
  { value: 'BAM', label: 'BAM (Bosnia Mark) - KM' },
  { value: 'BWP', label: 'BWP (Botswana Pula) - P' },
  { value: 'BRL', label: 'BRL (Brazilian Real) - R$' },
  { value: 'GBP', label: 'GBP (British Pound)' },
  { value: 'BND', label: 'BND (Brunei Dollar) - B$' },
  { value: 'BGN', label: 'BGN (Bulgarian Lev)' },
  { value: 'BIF', label: 'BIF (Burundian Franc) - Fbu' },
  { value: 'KHR', label: 'KHR (Cambodian Riel) - f' },
  { value: 'CAD', label: 'CAD (Canadian Dollar) - $' },
  { value: 'CVE', label: 'CVE (CapeVerdean Escudo) - Esc' },
  { value: 'KYD', label: 'KYD (CaymanIslands Dollar) - KY$' },
  { value: 'CLP', label: 'CLP (Chilean Peso) - $' },
  { value: 'CNY', label: 'CNY (Chinese Yuan)' },
  { value: 'COP', label: 'COP (Colombian Peso) - Col$' },
  { value: 'KMF', label: 'KMF (Comorian Franc) - CF' },
  { value: 'CDF', label: 'CDF (Congolese Franc) - F' },
  { value: 'CRC', label: 'CRC (CostaRican Colon)' },
  { value: 'HRK', label: 'HRK (Croatian Kuna) - kn' },
  { value: 'CUC', label: 'CUC (CubanConvertible Peso) - $' },
  { value: 'CZK', label: 'CZK (Czech Koruna)' },
  { value: 'DJF', label: 'DJF (Djiboutian Franc) - Fdj' },
  { value: 'DOP', label: 'DOP (Dominican Peso) - RD$' },
  { value: 'XCD', label: 'XCD (East Caribbean Dollar) - EC$' },
  { value: 'EGP', label: 'EGP (Egyptian Pound)' },
  { value: 'ERN', label: 'ERN (Eritrean Nakfa) - Nfa' },
  { value: 'EEK', label: 'EEK (Estonian Kroon) - KR' },
  { value: 'ETB', label: 'ETB (Ethiopian Birr) - Br' },
  { value: 'FKP', label: 'FKP (FalklandIsland Pound)' },
  { value: 'FJD', label: 'FJD (Fijian Dollar) - FJ$' },
  { value: 'GMD', label: 'GMD (Gambian dalasi) - D' },
  { value: 'GEL', label: 'GEL (Georgian Lari)' },
  { value: 'GHS', label: 'GHS (Ghanaian Cedi)' },
  { value: 'GIP', label: 'GIP (Gibraltar Pound)' },
  { value: 'GTQ', label: 'GTQ (Guatemalan Quetzal) - Q' },
  { value: 'GNF', label: 'GNF (Guinean Franc) - FG' },
  { value: 'GYD', label: 'GYD (Guyanese Dollar) - GY$' },
  { value: 'HTG', label: 'HTG (Haitian Gourde) - G' },
  { value: 'HNL', label: 'HNL (Honduran Lempira) - L' },
  { value: 'HKD', label: 'HKD (HongKong Dollar) - HK$' },
  { value: 'HUF', label: 'HUF (Hungarian Forint) - Ft' },
  { value: 'ISK', label: 'ISK (Icelandic Krona) - kr' },
  { value: 'INR', label: 'INR (Indian Rupee)' },
  { value: 'IDR', label: 'IDR (Indonesian Rupiah) - Rp' },
  { value: 'IRR', label: 'IRR (Iranian Rial)' },
  { value: 'IQD', label: 'IQD (Iraqi Dinar) - dinar' },
  { value: 'ILS', label: 'ILS (Israeli NewSheqel)' },
  { value: 'JMD', label: 'JMD (Jamaican Dollar) - J$' },
  { value: 'JPY', label: 'JPY (Japanese Yen)' },
  { value: 'JOD', label: 'JOD (Jordanian Dinar) - dinar' },
  { value: 'KZT', label: 'KZT (Kazakhstani Tenge) - T' },
  { value: 'KES', label: 'KES (Kenyan Shilling) - KSh' },
  { value: 'KPW', label: 'KPW (NorthKorean Won) - W' },
  { value: 'KRW', label: 'KRW (SouthKorean Won) - W' },
  { value: 'KWD', label: 'KWD (Kuwaiti Dinar) - KWD' },
  { value: 'KGS', label: 'KGS (Kyrgyzstani Som)' },
  { value: 'LAK', label: 'LAK (Lao Pound) - KN' },
  { value: 'LVL', label: 'LVL (Latvian Lats) - Ls' },
  { value: 'LBP', label: 'LBP (Lebanese Pound)' },
  { value: 'LSL', label: 'LSL (Lesotho Loti) - M' },
  { value: 'LRD', label: 'LRD (Liberian Dollar) - L$' },
  { value: 'LYD', label: 'LYD (Libyan Dinar) - LD' },
  { value: 'LTL', label: 'LTL (Lithuanian Litas) - Lt' },
  { value: 'MKD', label: 'MKD (Macedonian Denar) - denar' },
  { value: 'MWK', label: 'MWK (Malawian Kwacha) - MK' },
  { value: 'MYR', label: 'MYR (Malaysian Ringgit) - RM' },
  { value: 'MVR', label: 'MVR (Maldivian Rufiyaa) - Rf' },
  { value: 'MRO', label: 'MRO (Mauritanian Ouguiya) - UM' },
  { value: 'MUR', label: 'MUR (Mauritian Rupee) - Rs' },
  { value: 'MXN', label: 'MXN (Mexican Peso) - $' },
  { value: 'MDL', label: 'MDL (Moldovan Leu) - leu' },
  { value: 'MNT', label: 'MNT (Mongolian Tugrik)' },
  { value: 'MAD', label: 'MAD (Moroccan Dirham) - MAD' },
  { value: 'MZN', label: 'MZN (Mozambican Metical) - MTn' },
  { value: 'NAD', label: 'NAD (Namibian Dollar) - N$' },
  { value: 'NPR', label: 'NPR (Nepalese Rupee) - Rs' },
  { value: 'ANG', label: 'ANG (NetherlandsAntillean Guilder)' },
  { value: 'NZD', label: 'NZD (NewZealand Dollar) - NZ$' },
  { value: 'NIO', label: 'NIO (Nicaraguan Cordoba) - C$' },
  { value: 'NGN', label: 'NGN (Nigerian Naira)' },
  { value: 'NOK', label: 'NOK (Norwegian Krone) - kr' },
  { value: 'OMR', label: 'OMR (Omani Rial) - rial' },
  { value: 'PKR', label: 'PKR (Pakistani Rupee) - Rs.' },
  { value: 'PAB', label: 'PAB (Panamanian Balboa) - B./' },
  { value: 'PGK', label: 'PGK (PapuaNewGuinean Kina) - K' },
  { value: 'PYG', label: 'PYG (Paraguayan Guarani) - Gs' },
  { value: 'PEN', label: 'PEN (PeruvianNuevo Sol) - S/.' },
  { value: 'PHP', label: 'PHP (Philippine Peso)' },
  { value: 'PLN', label: 'PLN (Polish zloty)' },
  { value: 'QAR', label: 'QAR (Qatari Riyal) - QR' },
  { value: 'RON', label: 'RON (Romanian Leu) - L' },
  { value: 'RUB', label: 'RUB (Russian Ruble) - R' },
  { value: 'RWF', label: 'RWF (Rwandan Franc) - RF' },
  { value: 'SHP', label: 'SHP (SaintHelenian Pound)' },
  { value: 'WST', label: 'WST (Samoan Tala) - WS$' },
  { value: 'STD', label: 'STD (SaoTomeandPrincipe Dobra) - Db' },
  { value: 'SAR', label: 'SAR (Saudi Riyal) - SR' },
  { value: 'RSD', label: 'RSD (Serbian Dinar) - din.' },
  { value: 'SCR', label: 'SCR (Seychellois Rupee) - SR' },
  { value: 'SLL', label: 'SLL (SierraLeonean Leone) - Le' },
  { value: 'SGD', label: 'SGD (Singapore Dollar) - S$' },
  { value: 'SKK', label: 'SKK (Slovak Koruna)' },
  { value: 'SBD', label: 'SBD (SolomonIslands Dollar) - SI$' },
  { value: 'SOS', label: 'SOS (Somali Shilling) - Sh.' },
  { value: 'ZAR', label: 'ZAR (SouthAfrican Rand) - R' },
  { value: 'LKR', label: 'LKR (SriLankan Rupee) - Rs' },
  { value: 'SRD', label: 'SRD (Surinamese Dollar) - $' },
  { value: 'SZL', label: 'SZL (Swazi Lilangeni) - E' },
  { value: 'CHF', label: 'CHF (Swiss Franc) - Fr.' },
  { value: 'SYP', label: 'SYP (Syrian Pound)' },
  { value: 'TWD', label: 'TWD (TaiwaneseNew Dollar) - NT$' },
  { value: 'TJS', label: 'TJS (Tajikistani Somoni) - TJS' },
  { value: 'TZS', label: 'TZS (Tanzanian Shilling) - x/y' },
  { value: 'THB', label: 'THB (Thai Baht)' },
  { value: 'TOP', label: 'TOP (Tongan Paanga) - T$' },
  { value: 'TTD', label: 'TTD (TrinidadandTobago Dollar) - TT$' },
  { value: 'TND', label: 'TND (Tunisian Dinar) - DT' },
  { value: 'TMT', label: 'TMT (Turkmenistani Manat) - m' },
  { value: 'TRY', label: 'TRY (Turkish Lira) - YTL' },
  { value: 'UGX', label: 'UGX (Ugandan Shilling) - USh' },
  { value: 'UAH', label: 'UAH (Ukrainian Hryvnia)' },
  { value: 'AED', label: 'AED (UnitedArabEmirates Dirham) - Dhs' },
  { value: 'UYU', label: 'UYU (Uruguayan Peso) - $U' },
  { value: 'UZS', label: 'UZS (Uzbekistani Som)' },
  { value: 'VUV', label: 'VUV (Vanuatu Vatu) - VT' },
  { value: 'VEF', label: 'VEF (VenezuelanBolivar Fuertes) - Bs' },
  { value: 'VND', label: 'VND (Vietnamese Dong)' },
  { value: 'YER', label: 'YER (Yemeni Rial)' },
  { value: 'ZMK', label: 'ZMK (Zambian Kwacha) - ZK' },
  { value: 'ZWD', label: 'ZWD (Zimbabwean Dollar) - Z$' },
  { value: 'DKK', label: 'DKK (DanishKrone) - Kr' },
  { value: 'EUR', label: 'EUR (Euro)' },
  { value: 'CYP', label: 'CYP (Cyprus Pound)' },
  { value: 'ECS', label: 'ECS (Ecuadorian sucre) - S/.' },
  { value: 'XPF', label: 'XPF (French Polynesia) - FF' },
  { value: 'SEK', label: 'SEK (Swedish Krona) - kr' },
  { value: 'XOF', label: 'XOF (West African CFA franc)' },
  { value: 'MOP', label: 'MOP (Macanese pataca) - MOP$' },
  { value: 'SDG', label: 'SDG (Sudanese pound) - SDP' },
];
